import $ from "jquery";

const SUBMENU_BLOCK_SELECTOR = ".menu-item";

export class MenuModule {
    constructor() {
        this.$menuButton = $("[data-menu-trigger]");
        this.$menu = $("[data-menu-action]");
        this.$inactiveimageIcon = this.$menuButton.find(
            "[data-inactive-menu-icon]"
        );
        this.$activeimageIcon = this.$menuButton.find(
            "[data-active-menu-icon]"
        );

        this.$submenuButton = $(".main-nav-menu > li > .sub-menu > li > .has-children");
        this.addContainers();
        this.menuShowOnScroll();

    }

    init() {
        this.$menuButton.on("click", e => {
            this.handleClick(e);
        });

        this.$submenuButton.on("click", e => {
            const $target = $(e.currentTarget);
            const $parent = $target.closest(SUBMENU_BLOCK_SELECTOR);
            this.toggleThirdMenu(e, $parent);
        });

    }

    handleClick(e) {
        if (this.menuIsOpen()) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        $("body").addClass("prevent-scroll");
        this.$menu.addClass("active");
        this.$activeimageIcon.addClass("active");
        this.$inactiveimageIcon.removeClass("active");
        this.$menuButton.blur();
    }

    closeMenu(setFocusToBurger) {
        $("body").removeClass("prevent-scroll");
        this.$menu.removeClass("active");
        this.$activeimageIcon.removeClass("active");
        this.$inactiveimageIcon.addClass("active");

        if (typeof setFocusToBurger != "undefined" && setFocusToBurger) {
            this.$menuButton.focus();
        } else {
            this.$menuButton.blur();
        }
    }

    toggleThirdMenu(e, $parent) {
        e.preventDefault();
        $parent.toggleClass('show');
    }

    addContainers() {
        $('.social-media-nav-menu li a').wrap("<div class='hover-effect-3 hover-effect-3b'></div>").addClass('hover-effect');
    }
    menuIsOpen() {
        return this.$menu.hasClass("active");
    }

    menuShowOnScroll() {

        'use strict';

        var c, currentScrollTop = 0,
            navbar = $('.site-header');

        $(window).scroll(function () {
            var a = $(window).scrollTop();
            var b = navbar.height();

            currentScrollTop = a;

            if (a == 0) {
                navbar.removeClass("scrollUp");
            }

            if (c < currentScrollTop && a > b + b) {
                navbar.addClass("scrollDown");
                navbar.removeClass("scrollUp");
            }
            else if (c > currentScrollTop && !(a <= b)) {
                navbar.removeClass("scrollDown");
                navbar.addClass("scrollUp");
            }
            c = currentScrollTop;


        });

    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/MenuModule.js